import { VueConstructor } from "vue";
import BaseCard from "@/components/BaseCard.vue";
import BaseNavbar from "@/components/BaseNavbar.vue";
import BaseInput from "@/components/BaseInput.vue";
import FullPage from "@/components/FullPage.vue";
import BaseDropdown from "@/components/BaseDropdown.vue";
import BaseEditableField from "@/components/BaseEditableField.vue";
import Thumbnail from "@/components/Thumbnail.vue";
import BaseSwitch from "@/components/BaseSwitch.vue";
import BaseRadioInput from "@/components/BaseRadioInput.vue";
import BaseCheckbox from "@/components/BaseCheckbox.vue";
import BaseEditableTextarea from "@/components/BaseEditableTextarea.vue";
import DrageRow from "@/components/DrageRow.vue";
import HelpIcon from "@/components/HelpIcon.vue";
import Accordion from "@/components/accordion/Accordion.vue";
import AccordionItem from "@/components/accordion/AccordionItem.vue";
import TransitionExpand from "@/components/accordion/TransitionExpand.vue";
import InPlace from "@/components/InPlace.vue";
import NavigationDropdown from "@/components/NavigationDropdown.vue";
import SpinnerLoader from "@/components/SpinnerLoader.vue";
import FileUploader from "@/components/FileUploader.vue";
import BaseCounter from "@/components/BaseCounter.vue";
import PriceInput from "@/components/PriceInput.vue";
import Hoverable from "@/components/Hoverable.vue";

import Dropdown from "primevue/dropdown";
import InputNumber from "primevue/inputnumber";
import Calendar from "primevue/calendar";
import Dialog from "primevue/dialog";
import OverlayPanel from "primevue/overlaypanel";
import Sidebar from "primevue/sidebar";

import draggable from "vuedraggable";
import Multiselect from "vue-multiselect";

export default {
  install(Vue: VueConstructor) {
    Vue.component("base-card", BaseCard);
    Vue.component("base-navbar", BaseNavbar);
    Vue.component("base-input", BaseInput);
    Vue.component("page", FullPage);
    Vue.component("base-dropdown", BaseDropdown);
    Vue.component("base-editable-field", BaseEditableField);
    Vue.component("thumbnail", Thumbnail);
    Vue.component("draggable", draggable);
    Vue.component("accordion", Accordion);
    Vue.component("accordion-item", AccordionItem);
    Vue.component("transition-expand", TransitionExpand);
    Vue.component("BaseSwitch", BaseSwitch);
    Vue.component("BaseEditableTextarea", BaseEditableTextarea);
    Vue.component("prime-dropdown", Dropdown);
    Vue.component("prime-input-number", InputNumber);
    Vue.component("multiselect", Multiselect);
    Vue.component("DrageRow", DrageRow);
    Vue.component("BaseRadioInput", BaseRadioInput);
    Vue.component("BaseCheckbox", BaseCheckbox);
    Vue.component("HelpIcon", HelpIcon);
    Vue.component("InPlace", InPlace);
    Vue.component("Calendar", Calendar);
    Vue.component("Dialog", Dialog);
    Vue.component("NavigationDropdown", NavigationDropdown);
    Vue.component("SpinnerLoader", SpinnerLoader);
    Vue.component("FileUploader", FileUploader);
    Vue.component("BaseCounter", BaseCounter);
    Vue.component("PriceInput", PriceInput);
    Vue.component("OverlayPanel", OverlayPanel);
    Vue.component("Hoverable", Hoverable);
    Vue.component("Sidebar", Sidebar);
  }
};
